// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3d2I8","title":"Header_title__nx6Ki","left":"Header_left__3yW2o","clinicName":"Header_clinicName__1qcDF"};